import type { ProviderDirectoryEntry, ProviderDirectorySpecialty } from '../../../project_starburst';

export function toProviderDirectoryEntry(
  raw: XCaliberAPI.ProviderEntityIPC
): ProviderDirectoryEntry {
  const specialties: readonly XCaliberAPI.Specialty[] = Array.isArray(raw?.specialties)
    ? raw.specialties
    : [];
  const first = specialties[0];

  return {
    ehrId: raw?.provider_id || undefined,
    employerStatus: first?.report_grouper_six || first?.employment_designation || undefined,
    specialties: specialties.map(
      (s): ProviderDirectorySpecialty => ({
        role: s?.name ?? '',
        specialty: s?.specialty || undefined,
        location: s?.location || undefined,
        statusIndicator: s?.special_status_indicator || undefined,
        billable: s?.billable === true
      })
    )
  };
}
